// Instância Axios dedicada à API de Pendência e Notificação (detecção de
// documentos indeferidos e listagem de pendências em aberto de uma pessoa).
// Cada requisição recebe automaticamente o header Authorization: Bearer {token},
// lido do localStorage, e desloga o usuário se o token expirar/for inválido.
// Sem x-api-key: o front usa sempre JWT, que já restringe a pessoa a enxergar
// só a própria pendência (GET /pendencias/:pessoaId exige pessoaId do token
// igual ao da URL).

import axios from 'axios';

const pendenciaApi = axios.create({
  baseURL: process.env.REACT_APP_PENDENCIA_API_URL,
  timeout: 30000
});

pendenciaApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

pendenciaApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default pendenciaApi;
